import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./dashboard.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./dashboard.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { AuthService } from "../../shared/services/auth/auth.service";
import { of, switchMap } from "rxjs";
import { DashboardConstants } from "./dashboard.constants";
import { Router } from "@angular/router";
import { AppControllerService } from "../../app-controller.service";
import { UserInformationService } from "../../shared/services/user/user-information.service";
import { LocalStorageService } from "../../shared/services/storage/local-storage.service";
import { AppConfig } from "../../app.config";
import { AppRoutingConstants } from "../../app-routing.constants";
import { SearchApplicationsRoutingConstants } from "../../search-applications/search-applications-routing.constants";
import { NavPanService } from "../nav/nav-pane-content/nav-pan.service";
let DashboardComponent = class DashboardComponent {
    authService;
    changeDetector;
    router;
    appControllerService;
    userInformationService;
    localStorage;
    navService;
    howItWorks = DashboardConstants.HOW_IT_WORKS;
    howItWorksText = "";
    note = DashboardConstants.NOTE;
    noteText = "";
    overview = DashboardConstants.OVERVIEW;
    applicationText = DashboardConstants.APPLICATONS;
    InProgress = DashboardConstants.IN_PROGRESS;
    unCompleted = DashboardConstants.UNCOMPLETED;
    Completed = DashboardConstants.COMPLETED;
    aflaPortal;
    aflaPortalText = "";
    $authenticated;
    isAuthenticated;
    applicationsCount = 0;
    applicationInProgressCount = 0;
    applicationUncompletedCount = 0;
    applicationCompletedCount = 0;
    authenticatedSubscribe;
    constructor(authService, changeDetector, router, appControllerService, userInformationService, localStorage, navService) {
        this.authService = authService;
        this.changeDetector = changeDetector;
        this.router = router;
        this.appControllerService = appControllerService;
        this.userInformationService = userInformationService;
        this.localStorage = localStorage;
        this.navService = navService;
        this.$authenticated = this.navService.isNavigationBarLoaded$;
    }
    ngOnInit() {
        // this.redirectToDefaultLink();
        this.loadDashboarInformaton();
    }
    loadDashboarInformaton() {
        this.authenticatedSubscribe = this.$authenticated.pipe(switchMap(isAuthenticated => {
            if (isAuthenticated)
                this.isAuthenticated = isAuthenticated;
            this.changeDetector.markForCheck();
            if (isAuthenticated) {
                this.howItWorksText = AppConfig.settings.dashboard.howItWorksText;
                this.noteText = AppConfig.settings.dashboard.noteText;
                this.aflaPortalText = AppConfig.settings.dashboard.aflaPortalText;
                this.aflaPortal = AppConfig.settings.projectSettings.projectName;
                return this.userInformationService.retrieveMyPortalApplications();
            }
            else {
                return of(null);
            }
        })).subscribe(myApp => {
            if (myApp) {
                this.applicationsCount = myApp.value.length;
                this.applicationInProgressCount = myApp.value.filter(ap => ap.status !== "Not submitted" && (ap.percentComplete === null || ap.percentComplete.toString() !== "100")).length;
                this.applicationUncompletedCount = myApp.value.filter(ap => ap.status === "Not submitted").length;
                this.applicationCompletedCount = myApp.value.filter(ap => ap.status !== "Not submitted" && ap.percentComplete !== null && ap.percentComplete.toString() === "100").length;
            }
            this.changeDetector.markForCheck();
        });
    }
    onSearchApplicationClicked(filter) {
        if (filter === undefined || filter === null || filter === "" || filter.toLowerCase() === "all") {
            this.router.navigate([
                AppRoutingConstants.createRouteToView(SearchApplicationsRoutingConstants.SEARCH_APPLICATIONS_ROUTE)
            ]);
        }
        else {
            this.router.navigate([
                AppRoutingConstants.createRouteToView(SearchApplicationsRoutingConstants.SEARCH_APPLICATIONS_ROUTE, SearchApplicationsRoutingConstants.FILTERED_SEARCH_APPLICATIONS_ROUTE, filter)
            ]);
        }
    }
    static ctorParameters = () => [
        { type: AuthService },
        { type: ChangeDetectorRef },
        { type: Router },
        { type: AppControllerService },
        { type: UserInformationService },
        { type: LocalStorageService },
        { type: NavPanService }
    ];
};
DashboardComponent = __decorate([
    Component({
        selector: "app-nav",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], DashboardComponent);
export { DashboardComponent };
